const toDualDigit = (digit: number | string) => {
  return Number(digit) < 10 ? `0${digit}` : digit.toString();
};

export default toDualDigit;
